import {Module, Mutation, VuexModule} from 'vuex-module-decorators';

import {Notification} from '@/model/Notification';

@Module({name: 'NotificationStore', namespaced: true})
export class NotificationStore extends VuexModule {

  private notifications: Notification[] = [];

  @Mutation
  public addNotification(notification: Notification) {
    this.notifications.push(notification);
    this.notifications.sort((a, b) => b.Order - a.Order);
  }

  @Mutation
  public ackNotification(id: string) {
    this.notifications.find((n) => n.Id === id)?.Ack();
  }

  @Mutation
  public dismissNotification(id: string) {
    this.notifications.find((n) => n.Id === id)?.Dismiss();
  }

  @Mutation
  public removeNotification(id: string) {
    this.notifications = this.notifications.filter((n) => n.Id !== id);
    this.notifications.sort((a, b) => b.Order - a.Order);
  }

  @Mutation
  public clearNotifications() {
    this.notifications = [];
  }

  get Notifications(): Notification[] {
    return this.notifications;
  }

  get ActiveNotifications(): Notification[] {
    return this.Notifications.filter((n) => !n.Acknowledged);
  }

  get AcknowledgedNotifications(): Notification[] {
    return this.Notifications.filter((n) => n.Acknowledged);
  }

  get DisplayedNotifications(): Notification[] {
    return this.Notifications.filter((n) => !n.Acknowledged && !n.Dismissed);
  }
}
